// removed by extract-text-webpack-plugin
module.exports = {"slider":"slider__2RhxU","start":"start__Q9WUI","slide":"slide__3qejQ","slide__white":"slide__white__2oMXp","slide__active":"slide__active__wwOCn","slide_text":"slide_text__1x_jZ","slide_text__middle":"slide_text__middle__26SPx","slide_text__top":"slide_text__top__18Wpl","slide_text__center":"slide_text__center__2PG_m","slide_text__right":"slide_text__right__2qmt4","slide_media":"slide_media__Gtckp"};


//////////////////
// WEBPACK FOOTER
// ./components/Slider/Slider.scss
// module id = J096
// module chunks = 0